import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import SilaNavTabs from '../common/SilaNavTabs';
import CkoWebhooksForm from './CkoWebhooksForm';

function ThirdPartyWebhooks({ appId, admin = false }) {
  const { t } = useTranslation();
  const tabs = [
    {
      key: 'cko',
      label: t('applications.buttons.cko'),
      component: <CkoWebhooksForm appId={appId} admin={admin} />,
    },
  ];
  return <SilaNavTabs tabs={tabs} defaultTab="cko" />;
}

ThirdPartyWebhooks.propTypes = {
  /**
   * The id of the application
   */
  appId: PropTypes.number.isRequired,
  /**
   * The admin toggle to determine if the form is used for the admin console
   */
  admin: PropTypes.bool,
};

export default ThirdPartyWebhooks;
